import './date-modal.style.sass';
import template from './date-modal.tpl.pug';

class DateController {
    $onChanges(changeObject) {
        if (changeObject.timestamp) {
            this.timestamp = changeObject.timestamp.currentValue;
        }
        if (changeObject.title) {
            this.title = changeObject.title.currentValue;
        }
    }

    updateDate(timestamp) {
        this.timestamp = timestamp;
    }

    checkDayDisabled(timestamp) {
        return this.onDayCheckDisabled({
            data: timestamp
        });
    }

    dismiss() {
        this.onDismiss();
    }

    close() {
        return this.onClose({
            data: this.timestamp
        });
    }
}

export default {
    selector: 'dbADateModal',
    template: template(),
    controller: DateController,
    bindings: {
        title: '<',
        timestamp: '<',
        startOfWeek: '<',
        onDayCheckDisabled: '&',
        onClose: '&',
        onDismiss: '&'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/modals/component/date-modal/date-modal.cmpt.js